<ng-container *ngIf="selectedVariant">
    <div class="flex space-x-4 mb-2">
        <ng-container *ngIf="selectedVariant.stockLevel !== 'IN_STOCK'">
            <kb-stock-level-label [stockLevel]="selectedVariant?.stockLevel"></kb-stock-level-label>
        </ng-container>
    </div>
    <div class="flex flex-col">
        <div class="flex space-x-4 items-end" >
            <div class="font-bold text-3xl text-primary relative">
                <span>{{ selectedVariant?.priceWithTax | formatPrice }}</span>
            </div>
            <div class="flex flex-col">
                <div class="font-medium text-md text-red-700 opacity-70 " *ngIf="rrp" title="RRP">
                    <span class="line-through mr-1">{{ rrp | formatPrice }}</span>
                    <ng-container *ngIf="rrpPercent">(SAVE {{rrpPercent}}%)</ng-container>
                </div>
                <div class="flex">
                    <kb-special-price-badge [selectedVariant]="selectedVariant" class="block"></kb-special-price-badge>
                </div>
            </div>

        </div>
    </div>

</ng-container>

<div *ngIf="!selectedVariant" class="font-bold text-gray-500 mt-4">{{ selectOptionLabel | titlecase }}</div>

<div class="flex items-end space-x-6 mt-4" *ngIf="state$ | async as state">
    <ng-container *ngIf="!inCartQty; else inCartControls">

        <kb-quantity-input [(ngModel)]="qty" [min]="0" [max]="99" placeholder="Qty" label="Quantity"></kb-quantity-input>
        <div class="flex flex-grow flex-row items-center">
            <div (mouseenter)="addToCartHover.emit()">
                <button
                    [disabled]="
                        qty === 0 ||
                        selectedVariant?.stockLevel === 'OUT_OF_STOCK' ||
                        selectedVariant == null ||
                        state === 'processing'
                    "
                    [ngClass]="{ 'animate-pulse': state === 'processing' }"
                    class="btn btn-primary w-full lg:w-64 px-8"
                    (click)="addToCartClick.emit({ productVariantId: selectedVariant?.id, quantity: qty })"
                >
                    Add to cart
                </button>
            </div>
            <kb-add-to-wishlist-button
                class="block ml-1"
                [showLabel]="false"
                [disabled]="selectedVariant == null"
                [variantId]="selectedVariant?.id"
                [inWishlists]="inWishlists"
                (addClick)="addToWishlistClick.emit({ productVariantId: selectedVariant?.id, wishlistId: $event })"
                ></kb-add-to-wishlist-button>
        </div>
    </ng-container>
    <ng-template #inCartControls>
        <div>
            <kb-quantity-input
                [min]="0"
                [max]="99"
                placeholder="Qty"
                [hideButtons]="true"
                [label]="'Quantity'"
                [ngModel]="inCartQty"
                (ngModelChange)="adjustedQty[selectedVariant?.id] = $event"
            />
        </div>
        <div class="inline-flex items-center border border-primary-600 rounded">
            <button
                [disabled]="state === 'processing'"
                [ngClass]="{ 'animate-pulse': state === 'processing' }"
                *ngIf="adjustedQty[selectedVariant?.id] == null"
                class="btn btn-primary rounded-r-none"
                (click)="setQuantity.emit(inCartQty - 1)"
            >
                <fa-icon [icon]="minus"></fa-icon>
            </button>
            <kb-in-cart-label [inCartQty]="inCartQty"></kb-in-cart-label>
            <button
                [disabled]="state === 'processing'"
                [ngClass]="{ 'animate-pulse': state === 'processing' }"
                *ngIf="adjustedQty[selectedVariant?.id] == null"
                class="btn btn-primary rounded-l-none"
                (click)="setQuantity.emit(inCartQty + 1)"
            >
                <fa-icon [icon]="plus"></fa-icon>
            </button>
            <button
                [disabled]="state === 'processing'"
                [ngClass]="{ 'animate-pulse': state === 'processing' }"
                *ngIf="adjustedQty[selectedVariant?.id] != null"
                class="btn btn-primary rounded-l-none"
                (click)="setQuantity.emit(adjustedQty[selectedVariant?.id])"
            >
                Update
            </button>
        </div>
    </ng-template>
</div>
<kb-large-letter-label *ngIf="qualifiesForLetterboxService" />

